import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'SchoolTrips',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // School trips are managed by Admin (1) AND by school owner/admin (40/41).
        if (!this.requireUserType([1, 40, 41])) return;
        if (this.isSchoolAdmin()) {
            const sid = this.getSchoolId();
            this.selectedSchool = sid;
            this.ruleForm.SchoolId = sid;
        }
        this.GetInfo(this.pageNo);
        this.GetAllSchools();
        this.GetAllDrivers();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
   
        filteredStudents() {
            if (!this.studentSearch) return this.Students;

            return this.Students.filter(x =>
                (x.name || '').toLowerCase().includes(this.studentSearch.toLowerCase())
            );
        },

        filteredDrivers() {
            if (!this.driverSearch) return this.Drivers;
            const q = this.driverSearch.toLowerCase();
            return this.Drivers.filter(d =>
                (d.name || '').toLowerCase().includes(q) ||
                (d.phone || '').includes(q));
        },

        // Students currently on the route, filtered by manageCurrentSearch.
        filteredManageCurrent() {
            if (!this.manageCurrentSearch) return this.manageCurrentStudents;
            const q = this.manageCurrentSearch.toLowerCase();
            return this.manageCurrentStudents.filter(s =>
                (s.passengerName || '').toLowerCase().includes(q) ||
                (s.passengerPhone || '').includes(q));
        },

        // Students from the same school who are NOT already on this route.
        availableManageStudents() {
            const taken = new Set(this.manageCurrentStudents.map(s => Number(s.passengerId)));
            return this.manageAllSchoolStudents.filter(s => !taken.has(Number(s.id)));
        },

        filteredManageAvailable() {
            if (!this.manageAvailableSearch) return this.availableManageStudents;
            const q = this.manageAvailableSearch.toLowerCase();
            return this.availableManageStudents.filter(s =>
                (s.name || '').toLowerCase().includes(q) ||
                (s.phone || '').includes(q));
        }
    },

    data() {
        return {
            studentSearch:'',
            driverSearch: '',
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',
            selectedSchool: '',
            selectedDriver: '',

            ScreenTitle: 'رحلات المدرسية',
            ScreenTitleSingle: 'رحلة مدرسية',
            ScreenTitleSingleAl: 'الرحلة المدرسية',

            Info: [],
            Statistics: {},
            Schools: [],
            Drivers: [],
            Students: [],

            SelectedItem: '',
            TripDetails: {},
            // ترتيب نقاط التقاط الطلاب على المسار (نسخة قابلة للتعديل من SelectedItem.students).
            routeStops: [],
            ruleForm: {
                Id: 0,
                DriversId: '',
                SchoolId: '',
                ArrivalTime: '',
                DepartureTime: '',
                StartDate: '',
                EndDate: '',
                PassengerIds: []
            },
            changeDriverForm: {
                AssignmentId: 0,
                NewDriversId: ''
            },

            // ---- Manage Students modal state ----
            currentRoute: {},
            manageCurrentStudents: [],     // RouteStudentDto[] from GetStudents/{routeId}
            manageAllSchoolStudents: [],   // StudentItemDto[] from GetStudentsList?schoolsId
            manageCurrentSearch: '',
            manageAvailableSearch: '',

            // ---- Swap Group modal state (owner-only) ----
            swapTargetDriverId: '',

            // ---- Audit P1 #7: in-bus camera placeholder dialog ----
            cameraDialogVisible: false
        };
    },

    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetSchoolTrip(this.pageNo, this.pageSize, this.Search, this.selectedSchool, this.selectedDriver)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        GetStatistics() {
            this.$http.GetSchoolTripsStatistics()
                .then(response => {
                    this.Statistics = response.data;
                })
                .catch(() => {
                    this.Statistics = {};
                });
        },

        GetAllSchools() {
            this.$http.GetAllSchools()
                .then(response => {
                    this.Schools = response.data.info;
                })
                .catch(() => {
                    this.Schools = [];
                });
        },

        GetAllDrivers() {
            // BUG-11: in-bus cameras are a not-yet-shipped hardware placeholder,
            // so the camera filter matched zero drivers and the picker was empty
            // (which also blocked create — BUG-13). Load all approved drivers.
            this.$http.GetAllDrivers(false /* hasCamera */)
                .then(r => { this.Drivers = r.data.info; })
                .catch(() => { this.Drivers = []; });
        },

        // BUG-12: normalise a time input ("HH:mm" from <input type=time>, or an
        // already-"HH:mm:ss" value on edit) to the "HH:mm:ss" the API expects.
        toApiTime(t) {
            return t ? (String(t).length > 5 ? t : `${t}:00`) : null;
        },

        openAddDialog() {
            this.ClearForm(this.ruleForm);
            if (this.isSchoolAdmin()) this.ruleForm.SchoolId = this.getSchoolId();
            this.driverSearch = '';
            this.GetStudentsList();
        },
        GetStudentsList() {
            if (!this.ruleForm.SchoolId) {
                this.Students = [];
                this.ruleForm.PassengerIds = [];
                return;
            }

            if (!Array.isArray(this.ruleForm.PassengerIds)) {
                this.ruleForm.PassengerIds = [];
            }

            this.$http.GetSchoolTripsStudentsList(1, 1000, '', this.ruleForm.SchoolId)
                .then(response => {
                    this.Students = response.data.info || response.data.Info || [];
                })
                .catch(() => {
                    this.Students = [];
                });
        },

        submitForm() {
            const form = document.getElementById('routeForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');

            // BUG-12: send both arrival/departure times; the legacy single-time
            // column mirrors arrival so existing readers keep working.
            const arrival = this.toApiTime(this.ruleForm.ArrivalTime);
            const departure = this.toApiTime(this.ruleForm.DepartureTime);
            const body = {
                DriversId: Number(this.ruleForm.DriversId),
                SchoolId: Number(this.ruleForm.SchoolId),
                Time: arrival,
                ArrivalTime: arrival,
                DepartureTime: departure,
                StartDate: this.ruleForm.StartDate,
                EndDate: this.ruleForm.EndDate,
                PassengerIds: Array.isArray(this.ruleForm.PassengerIds)
                    ? this.ruleForm.PassengerIds.map(x => Number(x))
                    : []
            };

            this.$blockUI.Start();
            this.$http.CreateSchoolTrip(body)
                .then(() => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('Close');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إضافة المسار بنجاح');
                })
                .catch((err) => {
                    this.$blockUI.Stop();

                    let errorMsg = 'حدث خطأ غير متوقع';

                    if (err.response && err.response.data) {
                        if (typeof err.response.data === 'string') {
                            errorMsg = err.response.data;
                        } else if (err.response.data.message) {
                            errorMsg = err.response.data.message;
                        } else if (err.response.data.title) {
                            errorMsg = err.response.data.title;
                        } else {
                            errorMsg = JSON.stringify(err.response.data);
                        }
                    }

                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },


        ViewInfo(item) {
            this.SelectedItem = item;
            // ترتيب الالتقاط: انسخ الطلاب وزوّد كل واحد بحقل ترتيب قابل للتعديل.
            // إن وُجد stopOrder محفوظ من قبل نعرضه، وإلا نقترح ترتيباً تسلسلياً 1..N.
            this.routeStops = (item.students || []).map((s, i) => ({
                id: s.id,
                passengerId: s.passengerId,
                passengerName: s.passengerName,
                stopOrder: (s.stopOrder === 0 || s.stopOrder) ? Number(s.stopOrder) : (i + 1)
            }));
            this.state = 1;
        },

        // مسؤول/مالك المدرسة أو الأدمن العام فقط من يحدد ترتيب المسار.
        canSetRouteOrder() {
            const t = this.loginDetails ? Number(this.loginDetails.userType) : 0;
            return t === 1 || t === 40 || t === 41;
        },

        // إعادة ترقيم تسلسلية سريعة (1..N) حسب الترتيب الحالي للقائمة.
        renumberRouteStops() {
            this.routeStops.forEach((s, i) => { s.stopOrder = i + 1; });
        },

        saveRouteOrder() {
            if (!this.SelectedItem || !this.SelectedItem.id) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'لم يتم اختيار مسار');
                return;
            }
            if (!this.routeStops.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'لا يوجد طلاب على هذا المسار');
                return;
            }

            // تحقق: كل ترتيب رقم موجب، ولا تكرار بين الطلاب.
            const orders = this.routeStops.map(s => Number(s.stopOrder));
            if (orders.some(o => !o || o < 1 || !Number.isInteger(o))) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يجب أن يكون ترتيب كل طالب رقماً صحيحاً أكبر من صفر');
                return;
            }
            if (new Set(orders).size !== orders.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'لا يمكن تكرار نفس رقم الترتيب لأكثر من طالب');
                return;
            }

            const body = {
                AssignmentId: Number(this.SelectedItem.id),
                Stops: this.routeStops.map(s => ({
                    PassengerId: Number(s.passengerId),
                    StopOrder: Number(s.stopOrder)
                    // PickupLat / PickupLng اختيارية — تُترك للتطبيق/الإحداثيات الحية.
                }))
            };

            this.$blockUI.Start();
            this.$http.SetSchoolRouteOrder(body)
                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم حفظ ترتيب المسار بنجاح');
                    // حدّث القائمة الأساسية حتى يعكس الترتيب الجديد عند إعادة الفتح.
                    const ordered = [...this.routeStops]
                        .sort((a, b) => a.stopOrder - b.stopOrder)
                        .map(s => ({
                            id: s.id,
                            passengerId: s.passengerId,
                            passengerName: s.passengerName,
                            stopOrder: s.stopOrder
                        }));
                    this.SelectedItem.students = ordered;
                    this.routeStops = ordered.map(s => ({ ...s }));
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('error', 'خطأ', this.extractError(err));
                });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.DriversId = item.driversId;
            this.ruleForm.SchoolId = item.schoolId;
            // BUG-12: prefill arrival (fall back to legacy time) + departure as "HH:mm".
            this.ruleForm.ArrivalTime = (item.arrivalTime || item.time || '').toString().substring(0, 5);
            this.ruleForm.DepartureTime = (item.departureTime || '').toString().substring(0, 5);
            this.ruleForm.StartDate = item.startDate ? item.startDate.split('T')[0] : '';
            this.ruleForm.EndDate = item.endDate ? item.endDate.split('T')[0] : '';
            this.ruleForm.PassengerIds = item.students ? item.students.map(s => s.passengerId) : [];
            this.GetStudentsList();
        },

        submitEditForm() {
            const form = document.getElementById('routeForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');

            // D-11 fix (2026-05-24): previously this posted this.ruleForm raw, so Time
            // went out as "HH:mm" (no seconds) and failed server-side TimeOnly binding
            // -> 500. Build a cleaned payload exactly like the create path: normalise
            // Time to "HH:mm:ss" and coerce ids to numbers.
            // BUG-12: normalise to "HH:mm:ss"; legacy Time mirrors arrival.
            const arrival = this.toApiTime(this.ruleForm.ArrivalTime);
            const body = {
                Id: this.ruleForm.Id,
                DriversId: Number(this.ruleForm.DriversId),
                SchoolId: Number(this.ruleForm.SchoolId),
                Time: arrival,
                ArrivalTime: arrival,
                DepartureTime: this.toApiTime(this.ruleForm.DepartureTime),
                StartDate: this.ruleForm.StartDate,
                EndDate: this.ruleForm.EndDate,
                PassengerIds: Array.isArray(this.ruleForm.PassengerIds)
                    ? this.ruleForm.PassengerIds.map(x => Number(x))
                    : []
            };

            this.$blockUI.Start();
            this.$http.EditSchoolTrip(body)
                .then(() => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('Close');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تعديل المسار بنجاح');
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    // D-11 fix: render a readable message instead of "[object Object]".
                    let errorMsg = 'حدث خطأ غير متوقع';
                    if (err.response && err.response.data) {
                        if (typeof err.response.data === 'string') {
                            errorMsg = err.response.data;
                        } else if (err.response.data.message) {
                            errorMsg = err.response.data.message;
                        } else if (err.response.data.title) {
                            errorMsg = err.response.data.title;
                        } else {
                            errorMsg = JSON.stringify(err.response.data);
                        }
                    }
                    this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', errorMsg);
                });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هـل انت متأكد من عملية الحذف؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteSchoolTrip(Id)
                        .then(() => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم حذف المسار بنجاح');
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدث خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Back() {
            this.SelectedItem = '';
            this.state = 0;
            this.GetInfo(this.pageNo);
        },

        ViewTripDetails(item) {
            this.SelectedItem = item;
            this.TripDetails = {};
            this.$blockUI.Start();
            this.$http.GetTripDetails(item.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripDetails = response.data;
                    this.state = 2;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('error', 'خطأ', 'تعذر تحميل تفاصيل الرحلة');
                });
        },

        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },

        OpenChangeDriverDialog(item) {
            this.SelectedItem = item;
            this.changeDriverForm.AssignmentId = item.id;
            this.changeDriverForm.NewDriversId = '';
        },

        submitChangeDriver() {
            if (!this.changeDriverForm.NewDriversId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار السائق الجديد');
                return;
            }

            const body = {
                AssignmentId: Number(this.changeDriverForm.AssignmentId),
                NewDriversId: Number(this.changeDriverForm.NewDriversId)
            };

            this.$blockUI.Start();
            this.$http.ChangeSchoolTripDriver(body)
                .then(() => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.$helper.DestroyElemntById('CloseChangeDriver');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تغيير السائق بنجاح');
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        // ===== Manage Students (single add/remove) =====

        OpenManageStudents(item) {
            this.currentRoute = item || {};
            this.manageCurrentSearch = '';
            this.manageAvailableSearch = '';
            this.manageCurrentStudents = [];
            this.manageAllSchoolStudents = [];
            this.refreshManageStudents();
        },

        refreshManageStudents() {
            if (!this.currentRoute || !this.currentRoute.id) return;

            // Pull current roster for the route.
            this.$http.GetSchoolTripStudents(this.currentRoute.id)
                .then(res => {
                    this.manageCurrentStudents = (res.data && (res.data.info || res.data.Info)) || [];
                })
                .catch(() => { this.manageCurrentStudents = []; });

            // Pull candidate list (all Type=2 students in this school).
            if (this.currentRoute.schoolId) {
                this.$http.GetSchoolTripsStudentsList(1, 1000, '', this.currentRoute.schoolId)
                    .then(res => {
                        this.manageAllSchoolStudents = (res.data && (res.data.info || res.data.Info)) || [];
                    })
                    .catch(() => { this.manageAllSchoolStudents = []; });
            }
        },

        addStudent(routeId, studentId) {
            if (!routeId || !studentId) return;
            this.$blockUI.Start();
            this.$http.AddStudentToRoute(routeId, studentId)
                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إضافة الطالب إلى الرحلة');
                    this.refreshManageStudents();
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = 'حدث خطأ غير متوقع';
                    if (err.response && err.response.data) {
                        if (typeof err.response.data === 'string') errorMsg = err.response.data;
                        else if (err.response.data.Message) errorMsg = err.response.data.Message;
                        else if (err.response.data.message) errorMsg = err.response.data.message;
                    }
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        removeStudent(routeId, studentId) {
            if (!routeId || !studentId) return;
            this.$blockUI.Start();
            this.$http.RemoveStudentFromRoute(routeId, studentId)
                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إزالة الطالب من الرحلة');
                    this.refreshManageStudents();
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = 'حدث خطأ غير متوقع';
                    if (err.response && err.response.data) {
                        if (typeof err.response.data === 'string') errorMsg = err.response.data;
                        else if (err.response.data.Message) errorMsg = err.response.data.Message;
                        else if (err.response.data.message) errorMsg = err.response.data.message;
                    }
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        // ===== Swap Group (owner-only, SRS §3 "تبديل مجموعة من سائق لسائق آخر") =====

        OpenSwapGroup(item) {
            this.currentRoute = item || {};
            this.swapTargetDriverId = '';
            this.driverSearch = '';
        },

        swapGroup() {
            if (!this.currentRoute || !this.currentRoute.id) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'لم يتم اختيار رحلة');
                return;
            }
            if (!this.swapTargetDriverId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار السائق المستهدف');
                return;
            }
            if (Number(this.swapTargetDriverId) === Number(this.currentRoute.driversId)) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'السائق المستهدف هو نفس السائق الحالي');
                return;
            }

            this.$blockUI.Start();
            this.$http.SwapRouteGroup(Number(this.currentRoute.id), Number(this.swapTargetDriverId))
                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.DestroyElemntById('CloseSwapGroup');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تبديل المجموعة بنجاح');
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = 'حدث خطأ غير متوقع';
                    if (err.response && err.response.data) {
                        if (typeof err.response.data === 'string') errorMsg = err.response.data;
                        else if (err.response.data.Message) errorMsg = err.response.data.Message;
                        else if (err.response.data.message) errorMsg = err.response.data.message;
                    }
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        // ===== Audit P1 #9: advance the school-trip lifecycle from the dashboard =====
        // These act on the loaded trip detail (TripDetails.id is the real Trip id).
        extractError(err) {
            if (err && err.response && err.response.data) {
                const d = err.response.data;
                if (typeof d === 'string') return d;
                if (d.Message) return d.Message;
                if (d.message) return d.message;
            }
            return 'حدث خطأ غير متوقع';
        },

        reloadTripDetails() {
            if (!this.TripDetails || !this.TripDetails.id) return;
            this.$http.GetTripDetails(this.TripDetails.id)
                .then(res => { this.TripDetails = res.data; })
                .catch(() => { /* keep current view on transient errors */ });
        },

        startTrip() {
            const tripId = this.TripDetails && this.TripDetails.id;
            if (!tripId) return;
            Swal.fire({
                title: 'بدء الرحلة',
                text: 'هل تريد بدء هذه الرحلة المدرسية؟',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'بدء',
                cancelButtonText: 'إلغاء'
            }).then((r) => {
                if (!r.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.StartSchoolTrip(tripId)
                    .then(() => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم بدء الرحلة');
                        this.reloadTripDetails();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', this.extractError(err));
                    });
            });
        },

        completeTrip() {
            const tripId = this.TripDetails && this.TripDetails.id;
            if (!tripId) return;
            Swal.fire({
                title: 'إنهاء الرحلة',
                text: 'هل تريد إنهاء هذه الرحلة المدرسية؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'إنهاء',
                cancelButtonText: 'إلغاء'
            }).then((r) => {
                if (!r.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.CompleteSchoolTrip(tripId)
                    .then(() => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إنهاء الرحلة');
                        this.reloadTripDetails();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', this.extractError(err));
                    });
            });
        },

        busArrived(passengerId) {
            const tripId = this.TripDetails && this.TripDetails.id;
            if (!tripId || !passengerId) return;
            this.$blockUI.Start();
            this.$http.SchoolTripBusArrived(tripId, passengerId)
                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إرسال إشعار وصول الحافلة لولي الأمر');
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('error', 'خطأ', this.extractError(err));
                });
        },

        // ===== Audit P1 #7: in-bus camera "coming soon" notice =====
        // Hardware cameras are intentionally not installed yet. Rather than
        // wiring the dead mobile camera module, the detail-view camera button
        // opens a polished dialog that sets expectations.
        openCameraDialog() {
            this.cameraDialogVisible = true;
        }

    }
}
